import { render } from "./PricingNotAvailable.vue?vue&type=template&id=046e8499"
import script from "./PricingNotAvailable.vue?vue&type=script&lang=js"
export * from "./PricingNotAvailable.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/brekz-prestashop/brekz-prestashop/web/themes/brekz-2017/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__